// src/pages/blog/BlogList.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./blog.css";
import { posts } from "../../posts/postsIndex";

const BlogList = () => {
  const sorted = [...posts].sort((a, b) => (a.date < b.date ? 1 : -1));
  return (
    <div className="blog-container">
      <h1 className="blog-title">Blog</h1>
      <p className="blog-subtitle">Short posts about projects, CAD/CAM, and ML.</p>
      <ul className="blog-list">
        {sorted.map((p) => (
          <li key={p.slug} className="blog-card">
            <h2 className="blog-card-title">
              <Link to={`/blog/${p.slug}`}>{p.title}</Link>
            </h2>
            <div className="blog-card-meta">
              {new Date(p.date).toLocaleDateString()}
            </div>
            <p className="blog-card-summary">{p.summary}</p>
            <div className="blog-card-links">
              <Link to={`/blog/${p.slug}`} className="blog-readmore">
                Read →
              </Link>
              {p.repo && (
                <a className="blog-repo" href={p.repo} target="_blank" rel="noreferrer">
                  Code ↗
                </a>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlogList;
